module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rp-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.$bus.$emit('closeModal')
      }
    }
  }, [_c('div', {
    staticClass: "rp-modal"
  }, [_c('div', {
    staticClass: "rp-modal-header"
  }, [_c('div', {
    staticClass: "rp-rcontrols"
  }, [_c('a', {
    staticClass: "icon-times",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.$bus.$emit('closeModal')
      }
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Layer Settings")])]), _vm._v(" "), _c('div', {
    staticClass: "rp-modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-3",
    attrs: {
      "for": "layerName"
    }
  }, [_vm._v("Layer Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "layerName"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-9 col-sm-offset-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visible),
      expression: "visible"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.visible) ? _vm._i(_vm.visible, null) > -1 : (_vm.visible)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.visible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.visible = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.visible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.visible = $$c
        }
      }
    }
  }), _vm._v(" Visible\n\t\t\t\t\t\t\t")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "rp-modal-buttons"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Delete Layer")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$bus.$emit('closeModal')
      }
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0904d804"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/LayerInfoEditor.vue
// module id = 466
// module chunks = 0